import { render, staticRenderFns } from "./gb-whatsapp-media-not-showing-in-gallery.vue?vue&type=template&id=9da9168a&scoped=true"
import script from "./gb-whatsapp-media-not-showing-in-gallery.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-media-not-showing-in-gallery.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-media-not-showing-in-gallery.vue?vue&type=style&index=0&id=9da9168a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9da9168a",
  null
  
)

export default component.exports